var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowniverseLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1083,
    height: 136,
    viewBox: "0 0 1083 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        font-size: 25px;\r\n      }\r\n\r\n      .cls-1, .cls-10, .cls-2, .cls-9 {\r\n        fill: #020002;\r\n      }\r\n\r\n      .cls-1, .cls-10, .cls-2 {\r\n        font-family: Arial;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-2 {\r\n        font-size: 138px;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5 {\r\n        fill: #263c7b;\r\n      }\r\n\r\n      .cls-3, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        filter: url(#filter);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #544c92;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #1f52a0;\r\n      }\r\n\r\n      .cls-10 {\r\n        font-size: 20.833px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 194,
    y: 23.563,
    width: 119.5,
    height: 111.125,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 194,
    y: 23.5625,
    width: 119.5,
    height: 111.125,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTE5LjUiIGhlaWdodD0iMTExLjEyNSIgdmlld0JveD0iMCAwIDExOS41IDExMS4xMjUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB5MT0iNTUuNTYzIiB4Mj0iMTE5LjUiIHkyPSI1NS41NjMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmZiYTVlIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzI2M2M3YiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iMTE5LjUiIGhlaWdodD0iMTExLjEyNSIvPgo8L3N2Zz4K"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Growniverse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "GR",
    className: "cls-1",
    transform: "translate(-6.172 133.461) scale(5.172 5.519)"
  }, "GR"), /*#__PURE__*/React.createElement("text", {
    id: "WNIVERSE",
    className: "cls-2",
    x: 324.618,
    y: 134.136
  }, "WNIVERSE")), /*#__PURE__*/React.createElement("g", {
    id: "app-icon_copy",
    "data-name": "app-icon copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.4,28.469c-41.626,59.763,22.29,118.8,67.066,84.234,23.364-19.657-.126-52.932,11.479-67.605,3.961-1.26,2.233,11.156,2.472,14.877,1.845,7.782,12.279-3.035,2.533-19.883-4.385-9.284-6.624-12.795-3.034-16.352,3-2.714,18.612,24.537,18.592,47.473-1.054,24.054-10.035,57.365-57.119,63.291C203.68,138.852,170.373,70.015,214.4,28.469Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 286.594,
    cy: 34.375,
    r: 3.281
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 281.813,
    cy: 42.344,
    r: 2.094
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M310,42.058a27.213,27.213,0,0,1-7.58-16.33c0.254-3.386,4.484-.624,3.785.638C305.23,30.595,310,42.058,310,42.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M311.333,38.931c-0.358.093-2.536-2.816-2.748-8.088,0.195-4.645,3.389-3.274,3.222-.837C311.577,32.5,311.691,38.838,311.333,38.931Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "globe_copy",
    "data-name": "globe copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233.132,40.531S220.61,55.166,254.049,69.487c31.8,10.8,33-6.37,33-6.37s5.53,23.978-39.4,7.856C212.222,53.542,233.132,40.531,233.132,40.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M265.274,41.513h-19.7l9.332,13.748,21.773,0.982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M198.916,67.045"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.274,42.495s6.222,1.98,1.037-.982c-1.9-1.964-24.107-6.629-24.884,1.964-1.588,13.691,29.736,22.7,36.289,15.712,7-11.375-15.867-18.658-15.867-18.658l4.462,1.964s15.293,7.692,10.368,13.748c-7.528,9.39-32.908-4.644-32.142-11.784C245.833,34.557,265.274,42.495,265.274,42.495Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.284,69.991S207.47,85.785,240.39,99.451c28.34,10.393,42.511-.982,42.511-0.982s-9.591,15.712-45.622,2.946C202.545,87.34,209.284,69.991,209.284,69.991Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.542,100.433c14.1,20.776,44.585,13.748,44.585,13.748S232.851,118.058,216.542,100.433Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.053,48.387c-33.87,18.822-38.968,56.956-38.363,56.956C221.208,105.507,230.756,68.4,259.053,48.387Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.979,46.423c-5.011-2.455-49.25,6.792-44.584,46.155C213.259,55.015,249.635,47.323,256.979,46.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_copy",
    "data-name": "Shape 11 copy",
    className: "cls-6",
    d: "M261.5,49.01c1.777,37.155-29.218,61.972-29.547,61.491C231.525,110.178,259.19,82.384,261.5,49.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.579,52.315s-5.332,15.011,26.958,31.424c31.186,13.131,44.585-1.964,44.585-1.964s-9.091,20.02-46.659,4.91C206.063,69.43,217.579,52.315,217.579,52.315Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_copy",
    "data-name": "Shape 12 copy",
    className: "cls-6",
    d: "M266.649,50.878C271.439,53.7,284.373,100,245.493,114.7,281.294,95.44,269.587,57.316,266.649,50.878Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M304.674,131.858"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cap"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.794,39.334V24.6s3.943-8.787,23.038-8.623,23.75,8.623,23.75,8.623V40.531s-7.852-5.892-23.75-5.892C235.119,34.638,229.794,39.334,229.794,39.334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.358,15.98L254.906,0.268,296.38,18.926,279.79,24.6s-7.344-11.487-25.921-11.569c-19.441-.082-25.111,9.82-25.111,9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.707,16.089h2.086V35.845h-2.086V16.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.579,31.692V36.6s-3.11,2.885-3.11,3.928v2.946h7.7V40.531c0-1.136-3.11-3.928-3.11-3.928v-4.91h-1.477Z"
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "TM",
    className: "cls-10",
    x: 315.262,
    y: 24.842
  }, "TM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowniverseLogoFull);
export default __webpack_public_path__ + "static/media/growniverse-logo-full.03ef084947c54aac3382809639459b75.svg";
export { ForwardRef as ReactComponent };